<template>

	<div class="index-leader">


		<div class="big-title">
			<i class="fa fa-mortar-board"></i>
			<span>课程负责人</span>
		</div>


		<div class="index-leader-inner">


			<div class="img-block" :style="'background-image:url('+article.poster.url+')'"></div>

			<div class="text-center" v-show="article.loading">
				<i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
			</div>
			<div class="content-block" v-html="article.content"></div>

			<div class="title-block">
				<i class="fa fa-users"></i>
				<span>课程团队</span>
			</div>

			<div class="text-center" v-show="personPager.loading">
				<i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
			</div>

			<!-- Swiper -->
			<div class="swiper-container leader-swiper-container">
				<div class="swiper-wrapper">
					<div v-for="person in personPager.persons" class="swiper-slide leader-swiper-slide">
						<div class="avatar-name-block" @click.stop.prevent="person.click()">
							<div>

								<img class="avatar" v-if="person.image && person.image.url" :src="person.image.url"/>
							</div>
							<div class="person-name">
								{{person.name}}


							</div>
						</div>

					</div>
				</div>
			</div>


		</div>

	</div>

</template>


<script>

	import Swiper from "swiper";

	import Carousel from "../../../../../common/model/carousel/Carousel";
	import Person from "../../../../../common/model/person/Person";
	import Article from "../../../../../common/model/article/Article";
	import Pager from "../../../../../common/model/base/Pager";
	import {startWith} from "../../../../../common/filter/str";

	export default {

		props: {},
		data() {
			return {
				personPager: new Pager(Person),
				swiper: null,
				article: new Article()
			};
		},
		computed: {
			topic(){
				return this.$route.meta.topic;
			}
		},
		watch: {},
		methods: {

			refresh(){

				let that = this;
				this.personPager.httpFastPage(function () {

					setTimeout(function () {

						that.swiper = new Swiper('.leader-swiper-container', {
							autoplay: 3000,
							speed: 1000,
							// Optional parameters
							direction: 'horizontal',
							loop: true,

							paginationClickable: true,

							slidesPerView: 4,
							spaceBetween: 10
						});
					}, 200);


				})


			}
		},
		mounted(){
			this.refresh();

			this.article.id = 1;
			this.article.httpDetail();
		}
	};
</script>


<style lang="less" rel="stylesheet/less">


	.index-leader {

		.big-title {
			color: black;
			font-size: 18px;
			font-weight: bold;
			border-radius: 3px;
			padding-top: 10px;
		}

		.index-leader-inner {
			background-color: white;
			padding: 20px 20px 20px 20px;
			margin-top: 3px;
			.img-block {
				height: 180px;
				background-position: center center;
				background-size: cover;
				background-repeat: no-repeat;

				//background-image: url("../../../../../common/assets/img/course/leader.jpg");
			}

			.title-block {

				margin: 10px 0;

				color: black;
				font-size: 18px;
				font-weight: bold;
				border-radius: 3px;
			}
			.content-block {
				margin-top: 10px;

			}

			.leader-swiper-container {

				padding-bottom: 20px;

				.avatar-name-block {

					cursor: pointer;

					.avatar {
						max-width: 100%;
					}
					.person-name {
						text-align: center;

					}
				}
			}

		}

	}

</style>


// WEBPACK FOOTER //
// IndexLeader.vue?9c0f4782